module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card mdl-shadow--2dp",
    attrs: {
      "id": "chart-data"
    }
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "card-content"
  }, [_vm._v("\n        平均身長と標準偏差を調整できます。現代日本以外が舞台ならいじって見ても良いかも。"), _c('br'), _vm._v(" "), _vm._m(1), _vm._v("\n        平均身長(cm):"), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeAverage(-10)
      }
    }
  }, [_vm._v("-10")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeAverage(-5)
      }
    }
  }, [_vm._v("-5")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeAverage(-1)
      }
    }
  }, [_vm._v("-1")]), _vm._v(" "), _c('mdl-textfield', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.value.average),
      callback: function($$v) {
        _vm.value.average = $$v
      },
      expression: "value.average"
    }
  }), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeAverage(+1)
      }
    }
  }, [_vm._v("+1")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeAverage(+5)
      }
    }
  }, [_vm._v("+5")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeAverage(+10)
      }
    }
  }, [_vm._v("+10")])], 1), _vm._v(" "), _c('br'), _vm._v(" 標準偏差(cm): "), _c('span', {
    staticStyle: {
      "font-size": "12px",
      "color": "#333"
    }
  }, [_vm._v("データの散らばり具合")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "flex"
  }, [_c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeStddev(-5)
      }
    }
  }, [_vm._v("-5")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeStddev(-1)
      }
    }
  }, [_vm._v("-1")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeStddev(-0.1)
      }
    }
  }, [_vm._v("-0.1")]), _vm._v(" "), _c('mdl-textfield', {
    attrs: {
      "type": "number",
      "min": "0"
    },
    model: {
      value: (_vm.value.stddev),
      callback: function($$v) {
        _vm.value.stddev = $$v
      },
      expression: "value.stddev"
    }
  }), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeStddev(+0.1)
      }
    }
  }, [_vm._v("+0.1")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeStddev(+1)
      }
    }
  }, [_vm._v("+1")]), _vm._v(" "), _c('mdl-button', {
    staticClass: "mdl-button--raised",
    nativeOn: {
      "click": function($event) {
        _vm.changeStddev(+5)
      }
    }
  }, [_vm._v("+5")])], 1), _vm._v(" "), _c('br'), _vm._v("\n        正規分布 [縦:確率(%) 横:身長(cm)]:\n        "), _c('chart', {
    attrs: {
      "average": _vm.value.average,
      "stddev": _vm.value.stddev
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdl-card__title mdl-color--primary mdl-color-text--primary-contrast "
  }, [_c('h2', {
    staticClass: "mdl-card__title-text"
  }, [_vm._v("平均と標準偏差")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', [_c('li', [_vm._v("寒冷な地域では身長が高め?")]), _vm._v(" "), _c('li', [_vm._v("栄養摂取が不十分だと身長が低め?")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-74495143!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ChartData.vue
// module id = 189
// module chunks = 0